import React from 'react';
import { Card, CardContent, Grid, Typography } from '@mui/material';
import VoverPlansSelector from '@components/pricing/VoverPlansSelector';

interface CapacityPack {
  capacity: number;
  price: number;
  highlight?: string;
}

interface SignupGestaoPlanSelectorProps {
  gestaoPlanPacks: CapacityPack[];
  selectedCapacity: number;
  fieldError: string | undefined;
  onSelectCapacity: (capacity: number) => void;
}

/**
 * Seletor de capacidade do plano Gestão (VCondo Planos) no cadastro. Extraído de SignupForm.tsx (F7).
 */
export const SignupGestaoPlanSelector: React.FC<SignupGestaoPlanSelectorProps> = ({
  gestaoPlanPacks,
  selectedCapacity,
  fieldError,
  onSelectCapacity,
}) => {
  if (gestaoPlanPacks.length === 0) return null;

  return (
    <Grid item xs={12}>
      <Card variant="outlined" sx={fieldError ? { borderColor: 'error.main', borderWidth: 2 } : {}}>
        <CardContent>
          <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold', color: 'primary.main' }}>
            VCondo Planos
          </Typography>
          {fieldError && (
            <Typography variant="caption" color="error" sx={{ display: 'block', mb: 1 }}>
              {fieldError}
            </Typography>
          )}
          <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
            Escolha o plano ideal para a capacidade de condomínios da sua operação.
          </Typography>
          <VoverPlansSelector
            packs={gestaoPlanPacks}
            selectedCapacity={selectedCapacity || gestaoPlanPacks[0]?.capacity || 0}
            onSelectCapacity={onSelectCapacity}
            recommendedIndex={Math.max(0, gestaoPlanPacks.findIndex((p) => Boolean(p.highlight)))}
          />
        </CardContent>
      </Card>
    </Grid>
  );
};

export default SignupGestaoPlanSelector;
